import { render } from "./ContextbarSettings.vue?vue&type=template&id=16b0185e&scoped=true"
import script from "./ContextbarSettings.vue?vue&type=script&lang=js"
export * from "./ContextbarSettings.vue?vue&type=script&lang=js"

import "./ContextbarSettings.vue?vue&type=style&index=0&id=16b0185e&lang=css"
import "./ContextbarSettings.vue?vue&type=style&index=1&id=16b0185e&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b0185e"]])

export default __exports__